import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ProcessingTimeSpec } from '../processing-time-spec'
import { ProcessingTimeUtils } from '../processing-time-utils'
import { ProcessingTimeSpecDetailComponent } from '../processing-time-spec-detail/processing-time-spec-detail.component'

export interface IProcessingTimeSpecDialogOptions {
  readonly pTime: ProcessingTimeSpec
}

@Component({
  selector: 'app-processing-time-spec-detail-dialog',
  templateUrl: './processing-time-spec-detail-dialog.component.html',
  styleUrls: ['./processing-time-spec-detail-dialog.component.scss'],
  imports: [ProcessingTimeSpecDetailComponent],
})
export class ProcessingTimeSpecDetailDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly pTime: ProcessingTimeSpec
  public readonly original: ProcessingTimeSpec
  dialogRef = inject<MatDialogRef<ProcessingTimeSpecDetailDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IProcessingTimeSpecDialogOptions>(MAT_DIALOG_DATA)
    this.pTime = new ProcessingTimeSpec()
    this.original = data.pTime
    ProcessingTimeUtils.update(this.original, this.pTime)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose($event: Event): void {
    this.close()
  }

  public onSave($event: Event): void {
    this.close(this.pTime)
  }

  public close(pTime?: ProcessingTimeSpec): void {
    this.dialogRef.close(pTime)
  }
}
